import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"

import FallingLeaves from "./FallingLeaves"
import Primary3DButton from "../../components/buttons/Primary3DButton"
import SecondaryTransparentButton from "../../components/buttons/SecondaryTransparentButton"
import OnboardingPageContentWrapper from "../../components/onboarding/onboardingPageContentWrapper/OnboardingPageContentWrapper"
import OnboardingPageWrapper from "../../components/onboarding/onboardingPageWrapper/OnboardingPageWrapper"
import useMediaQuery from "../../hooks/useMediaQuery"
import useMobile from "../../hooks/useMobile"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { useRouter } from "../../util/router"
import { useInviteCodeStore } from "../invite/useInviteCodeStore"

const WelcomeContent = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { setIsInvited } = useInviteCodeStore()
  const router = useRouter()

  const { t } = useTranslation()
  const isMobile = useMobile()
  const isSmallMobile = useMediaQuery("(max-width: 500px)")

  return (
    <OnboardingPageWrapper
      style={{
        backgroundImage: isSmallMobile
          ? `url("/images/background/welcome-bg-mobile.png")`
          : isMobile
            ? `url("/images/background/welcome-bg.png")`
            : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {!isMobile && <FallingLeaves />}
      <OnboardingPageContentWrapper
        backgroundImageOnDesktop={
          isSmallMobile ? "none" : `url("/images/background/welcome-bg.png")`
        }
      >
        {isMobile && <FallingLeaves snowflakeCount={20} />}
        <FlexBox direction="column" align="center" gap={SPACING.space1}>
          <img
            src="/images/logos/logo_white.svg"
            alt="Joon"
            style={{
              width: "130px",
              zIndex: 1,
              marginBottom: SPACING.space3,
              userSelect: "none",
              pointerEvents: "none",
              opacity: isLoading ? 0 : 1,
              transition: "opacity 0.1s ease-in-out",
            }}
            onLoad={() => setIsLoading(false)}
          />
          <Typography
            variant="bodyBold"
            color={JoonUIColor.text.primary}
            style={{ zIndex: 1 }}
            textAlign="center"
          >
            {t("WELCOME_TAGLINE")}
          </Typography>
          <Typography
            variant="body"
            color={JoonUIColor.text.primary}
            style={{ zIndex: 1 }}
            textAlign="center"
          >
            {t("WELCOME_SUBTITLE")}
          </Typography>
        </FlexBox>
        <FlexBox direction="column" gap={SPACING.space3} style={{ zIndex: 1 }}>
          <Primary3DButton
            text={t("WELCOME_GET_STARTED")}
            onClick={() => {
              setIsInvited(false)
              trackAnalyticEvent(ANALYTIC_EVENTS.AUTH_NO_ACCOUNT)
              router.push("/invite")
            }}
          />
          <SecondaryTransparentButton
            text={t("AUTH_SIGN_IN_EXISTING")}
            onClick={() => {
              trackAnalyticEvent(ANALYTIC_EVENTS.AUTH_HAS_ACCOUNT)
              router.push("/auth/signin")
            }}
          />
          <Typography
            variant="bodyXSmallBold"
            textAlign="center"
            style={{ marginTop: SPACING.space2 }}
          >
            <Trans
              i18nKey="WELCOME_TERMS"
              components={{
                // Trans injects the translated text as children at runtime;
                // the inline text is the fallback and keeps the anchors a11y-valid.
                terms: (
                  <a
                    href="https://www.joonapp.io/terms-of-service"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    Terms of Service
                  </a>
                ),
                privacy: (
                  <a
                    href="https://www.joonapp.io/privacy-policy"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    Privacy Policy
                  </a>
                ),
              }}
            />
          </Typography>
        </FlexBox>
      </OnboardingPageContentWrapper>
    </OnboardingPageWrapper>
  )
}

export default WelcomeContent
